//@flow

import React from 'react';

type Props = { close: () => void };

export default class BackButtonHijack extends React.Component<Props> {
  onBackButtonEvent = () => this.props.close();

  componentDidMount() {
    const { history, location } = window;
    history.pushState(null, null, location.href);
    window.addEventListener('popstate', this.onBackButtonEvent, true);
  }
  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackButtonEvent, true);
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/BackButtonHijack.jsx